import Loading from '~/components/Loading';
import Home from '~/views/Home';
import Novo from '~/views/Novo';
import Finalizar from '~/views/Novo/Finalizar';
import InformarDados from '~/views/Novo/InformarDados';
import TipoTemplate from '~/views/Novo/TipoTemplate';

const routes = [
  {
    key: 'login',
    private: false,
    exact: true,
    path: '/',
    component: Loading,
    active: true,
    text: 'Acessando o sistema...',
    fullscreen: true,
  },
  {
    key: 'home',
    private: true,
    exact: true,
    path: '/home',
    component: Home,
  },
  {
    key: 'tipo-template',
    private: true,
    exact: true,
    path: '/novo/tipo-template',
    component: Novo,
    Children: TipoTemplate,
  },
  {
    key: 'informar-dados',
    private: true,
    exact: true,
    path: ['/novo/informar-dados', '/editar/informar-dados'],
    component: Novo,
    Children: InformarDados,
  },
  {
    key: 'finalizar',
    private: true,
    exact: true,
    path: ['/novo/finalizar', '/editar/finalizar'],
    component: Novo,
    Children: Finalizar,
  },
];

export default routes;
